/**
 * MatryxPlatform.js
 * Class for parsing values from MatryxPlatform smart contract
 *
 * Authors dev@nanome.ai
 * Copyright (c) 2018, Nanome Inc
 * Licensed under ISC. See LICENSE.md in project root.
 */

import { fromWei, toWei } from ".."
import Contract from "./Contract"

export default class MatryxPlatform extends Contract {
  async getInfo() {
    return await this.contract.getInfo()
  }

  async isTournament(address) {
    return await this.contract.isTournament(address)
  }

  async isSubmission(submissionHash) {
    return await this.contract.isSubmission(submissionHash)
  }

  async isCommit(commitHash) {
    return await this.contract.isCommit(commitHash)
  }

  async getTotalBalance() {
    let balance = await this.contract.getTotalBalance()
    return fromWei(balance)
  }

  async getTournamentBalance(address) {
    let balance = await this.contract.getTournamentBalance(address)
    return fromWei(balance)
  }

  async getCommitBalance(commitHash) {
    let balance = await this.contract.getCommitBalance(commitHash)
    return fromWei(balance)
  }

  async getTournamentCount() {
    let count = await this.contract.getTournamentCount()
    return +count
  }

  async getTournaments() {
    return await this.contract.getTournaments()
  }

  async getSubmission(submissionHash) {
    let submission = await this.contract.getSubmission(submissionHash)

    submission.roundIndex = +submission.roundIndex
    submission.reward = fromWei(submission.reward)

    submission.timestamp = +submission.timestamp
    submission.date = new Date(1000 * submission.timestamp)

    return submission
  }

  // TRANSACTION FUNCTIONS BELOW

  async createTournament(tData, rData) {
    // tData expects:
    //   content: string
    //   bounty: number (MTX)
    //   entryFee: number (MTX)

    // rData expects:
    //   start: date
    //   duration: number (s)
    //   review: number (s)
    //   bounty: number (MTX)

    tData = JSON.parse(JSON.stringify(tData))
    rData = JSON.parse(JSON.stringify(rData))

    tData.bounty = toWei(tData.bounty)
    tData.entryFee = toWei(tData.entryFee)

    rData.start = Math.floor(new Date(rData.start) / 1000)
    rData.bounty = toWei(rData.bounty)
    return await this.contract.createTournament(tData, rData)
  }
}
